module.exports = __webpack_public_path__ + "img/faqArrow.d850293d.svg";